import { createContext, FC, useState } from 'react';

type DebugInfo = {
  message: string[];
  recordingPreview: boolean;
};
export type DebugModeContextProps = DebugInfo & {
  updateDebugMode: React.Dispatch<React.SetStateAction<DebugInfo>>;
  addMessage: (message: string) => void;
  toggleRecordingPreview: () => void;
};

export const DebugModeContext = createContext<DebugModeContextProps>(null as any);

type Props = {
  children: React.ReactNode;
};
const DebugModeProvider: FC<Props> = ({ children }) => {
  const [debugModeInfo, setDebugModeInfo] = useState<DebugInfo>({ message: [], recordingPreview: false });

  return (
    <DebugModeContext.Provider
      value={{
        ...debugModeInfo,
        updateDebugMode: setDebugModeInfo,
        addMessage: (message) => {
          setDebugModeInfo((prev) => {
            return {
              ...prev,
              message: [...prev.message, message]
            };
          });
        },
        toggleRecordingPreview: () => {
          setDebugModeInfo((prev) => {
            return {
              ...prev,
              recordingPreview: !prev.recordingPreview
            };
          });
        }
      }}
    >
      {children}
    </DebugModeContext.Provider>
  );
};
export default DebugModeProvider;
